import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty } from 'lodash';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Listings } from 'containers/AppContainer/typings';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  ExpertReportType,
  IVehiculeExpertise,
  IVictimExpertise,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import ExpertReport from 'containers/common/LegalProceedings/ExpertReport';
import { Container } from 'containers/LawyerLegalProceedingsPage/ExpertReport/styled-components';
import { useFormatExpertReportState } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/hooks';
import { extractExpertReport } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/utils';
import { medicalExpertisesValidator } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/form-validations';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { DOCUMENT_TYPES } from 'constants/global';
import { handleOpenDocument } from 'services/utils';
import Document from 'components/Document';

export interface JudiciaryExpertiseProps {
  intl: IntlShape;
  judgementAddDocuments: JudgementADDDocumentType[];
  listings: Listings;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  documentId: string;
  setDocumentId: Function;
  requestCreateExpertiseRaport: Function;
  claimId: number;
  claimNumber: string;
  requestGetExpertiseRaport: Function;
  expertiseReport: ExpertReportType;
  readOnly?: boolean;
  isManager?: boolean;
  judiciaryProcessId: number;
  requestAddExpertiseSupportDocument?: Function;
  requestValidateExpertReport?: Function;
  currentJudiciaryProcess?: any;
  isAssignedLawyer: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  requestGetDocByDocumentumId: Function;
}

export const JudiciaryExpertise: React.FC<JudiciaryExpertiseProps> = ({
  ...props
}): JSX.Element => {
  const [expertReportState, setExpertReportState] = useFormatExpertReportState(
    props.judgementAddDocuments,
    props.expertiseReport,
  );

  const { victimExpertises, vehiculeExpertises } = extractExpertReport(
    expertReportState,
    (v: IVictimExpertise) => !isEmpty(v.victimExpertise),
    (v: IVehiculeExpertise) => !isEmpty(v.vehiculeExpertise),
  );
  let validateVictimExpertise = {};

  if (victimExpertises[0]) {
    validateVictimExpertise = medicalExpertisesValidator(victimExpertises[0]);
  }

  const expertiseSupportDocuments = get(
    props.expertiseReport,
    'supportDocuments',
    [],
  ).filter(
    (el: any) => el.type === DOCUMENT_TYPES.SUPPORT_DOCUMENT_EXPERT_REPORT,
  );
  return (
    <Container id="lawyer-expert-report">
      {(!isEmpty(props.expertiseReport.victimExpertises) ||
        !isEmpty(props.expertiseReport.vehiculeExpertises)) && (
        <ExpertReport
          claimId={props.claimId}
          expertReport={props.expertiseReport}
          listings={props.listings}
          documentId={props.documentId}
          setDocumentId={props.setDocumentId}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          expertReportState={expertReportState}
          setExpertReportState={setExpertReportState}
          validateVictimExpertise={validateVictimExpertise}
          isAssignedLawyer={props.isAssignedLawyer}
          claimNumber={props.claimNumber}
          victimExpertises={victimExpertises}
          vehicleExpertises={vehiculeExpertises}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          imagineDocuments={[]}
          expertiseRaportFirstInstance={[]}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      {featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
        !isEmpty(props.expertiseReport) &&
        !isEmpty(expertiseSupportDocuments) && (
          <main>
            <section>
              <div className="support-document-info">
                <Document
                  name={get(expertiseSupportDocuments[0], 'name', '')}
                  type={get(expertiseSupportDocuments[0], 'type', '')}
                  icon={
                    <VisibilityIcon
                      className="consult"
                      onClick={handleOpenDocument(
                        expertiseSupportDocuments[0] as any,
                        props.requestGetDocByDocumentumId,
                      )}
                    />
                  }
                />
              </div>
            </section>
          </main>
        )}
    </Container>
  );
};

export default injectIntl(JudiciaryExpertise);
